import { render, staticRenderFns } from "./LiquidadosDevueltos.vue?vue&type=template&id=96b2a522"
import script from "./LiquidadosDevueltos.vue?vue&type=script&lang=js"
export * from "./LiquidadosDevueltos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports